import * as React from 'react'
import PricingPopover from 'components/ui/pricing-popover'
type Props = {
  popoverProps: {
    messageClassName?: string
    description?: (string | null | undefined) | React.ReactNode
  }
  isShow: boolean
  children: React.ReactNode
}

const PricingPagePopover = (props: Props): React.ReactNode => {
  const { isShow, children, popoverProps } = props

  if (popoverProps.description) {
    popoverProps.description = (
      <span className="Pricing_PricingPopoverMessage">
        {popoverProps.description}
      </span>
    )
  }

  const elProps = isShow ? popoverProps : {}
  return React.createElement(
    isShow ? PricingPopover : React.Fragment,
    { ...elProps } as any,
    children,
  )
}

export default PricingPagePopover
